/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { defineComponent } from "vue";
import { IMdModal } from ".";

export default defineComponent({
  emits: ["cancel", "submit"],
  props: {
    loading: Boolean,
  },
  methods: {
    open() {
      (this.$refs.modal as IMdModal).open();
    },
    close() {
      (this.$refs.modal as IMdModal).close();
    },
    /**
     *
     * @param state true = display the loader, false = no loader
     */
    setLoadingState(state: boolean) {
      (this.$refs.modal as IMdModal).setLoadingState(state);
    },
  },
});
